import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Icon } from "./Icon";
/**
 * CheckmarkIcon - A checkmark icon used for accept/confirm actions
 */
export const CheckmarkIcon = ({ size = 16, color = "#374151", variant = "simple", circleColor = "#10B981", checkColor = "white", className = "", ...props }) => {
    if (variant === "circle") {
        return (_jsxs(Icon, { size: size, viewBox: "0 0 16 16", className: className, ...props, children: [_jsx("circle", { cx: "8", cy: "8", r: "6.5", fill: circleColor }), _jsx("path", { d: "M11 6L7 10L5 8", stroke: checkColor, strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" })] }));
    }
    return (_jsx(Icon, { size: size, color: color, viewBox: "0 0 16 16", className: className, ...props, children: _jsx("path", { d: "M13.3346 4L6.0013 11.3333L2.66797 8", stroke: color, strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }) }));
};
